const setting = import('@/components/setting'),
	createChangePassword = import('@/components/setting/create-change-password'),
	changeEmail = import('@/components/setting/change-email'),
	changeSecurity = import('@/components/setting/change-security'),
	challengeSecurity = import('@/components/setting/challenge-security'),
	addSecurityQuestion = import('@/components/setting/add-security-questions'),
	resetAccount = import('@/components/setting/reset-account'),
	revertId = import('@/components/revert-id'),
	revertIdSuccess = import('@/components/revert-id-success'),
	verifyAccount = import('@/components/setting/verify-account');

export default [
	{
		path: '/:locale/setting',
		name: 'setting',
		components: {
			body: () => setting,
		},
		meta: { requireSettingsInfo: true },
	},
	{
		path: '/:locale/setting/verify-account',
		name: 'verify-account',
		components: {
			body: () => verifyAccount,
		},
		meta: { requireSettingsInfo: true },
	},
	{
		path: '/:locale/setting/challenge-security',
		name: 'challenge-security',
		components: {
			body: () => challengeSecurity,
		},
		meta: { requireSettingsInfo: true },
	},
	{
		path: '/:locale/setting/password/:type?',
		name: 'create-change-password',
		components: {
			body: () => createChangePassword,
		},
		meta: { requireSettingsInfo: true },
	},
	{
		path: '/:locale/setting/change-email',
		name: 'change-email',
		components: {
			body: () => changeEmail,
		},
		meta: { requiresLogin: true },
	},
	{
		path: '/:locale/setting/change-security',
		name: 'change-security',
		components: {
			body: () => changeSecurity,
		},
		meta: { requireSettingsInfo: true },
	},
	{
		path: '/:locale/setting/add-security-question',
		name: 'add-security-question',
		components: {
			body: () => addSecurityQuestion,
		},
		meta: { requireSettingsInfo: true },
	},
	{
		path: '/:locale/setting/reset-account',
		name: 'reset-your-account',
		components: {
			body: () => resetAccount,
		},
		meta: { requireSettingsInfo: true },
	},
	{
		path: '/:locale/revert-id',
		name: 'revert-id',
		components: {
			body: () => revertId,
		},
	},
	{
		path: '/:locale/revert-id-success',
		name: 'revert-id-success',
		components: {
			body: () => revertIdSuccess,
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/routes/setting.js